import { _ } from '../../utils/l10n';

export const HighlightText = ({ children }: { children: React.ReactNode }) => (
  <span className="primary-text">{children}</span>
);
